(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('billing-schedule', {
                parent: 'entity',
                url: '/billing-schedule',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'BillingSchedule'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/billing-schedule/list/billing-schedule.html',
                        controller: 'BillingScheduleController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
